export interface DayHours {
  day: string;
  hours: string;
}

export const businessHours: DayHours[] = [
  {
    day: "Mon – Fri",
    hours: "9:00 AM - 9:00 PM"
  },
  {
    day: "Saturday",
    hours: "8:00 AM - 6:00 PM"
  },
  {
    day: "Sunday",
    hours: "10:00 AM - 4:00 PM"
  }
];